"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const isRangeAssigned_1 = require("../../../data/data1d/Spectrum1D/isRangeAssigned");
const RangeUtilities_1 = require("../../../data/utilities/RangeUtilities");
const AssignmentsContext_1 = require("../../assignment/AssignmentsContext");
const filterForIDsWithAssignment_1 = require("../../assignment/utilities/filterForIDsWithAssignment");
const DispatchContext_1 = require("../../context/DispatchContext");
const GlobalContext_1 = require("../../context/GlobalContext");
const ScaleContext_1 = require("../../context/ScaleContext");
const Resizer_1 = __importDefault(require("../../elements/resizer/Resizer"));
const highlight_1 = require("../../highlight");
const useResizerStatus_1 = require("../../hooks/useResizerStatus");
const ToolTypes_1 = require("../../toolbar/ToolTypes");
const IntegralIndicator_1 = require("../integral/IntegralIndicator");
const MultiplicityTree_1 = require("../multiplicityTree/MultiplicityTree");
const AssignmentActionsButtons_1 = require("./AssignmentActionsButtons");
const style = (0, react_1.css) `
  .target {
    visibility: hidden;
  }

  &:hover {
    .target {
      visibility: visible;
    }
  }
`;
function Range({ range, showMultiplicityTrees, selectedTool, relativeFormat, }) {
    const { viewerRef } = (0, GlobalContext_1.useGlobal)();
    const { id, integration, signals, diaIDs } = range;
    const assignmentData = (0, AssignmentsContext_1.useAssignmentData)();
    const assignmentRange = (0, AssignmentsContext_1.useAssignment)(id);
    const highlightRange = (0, highlight_1.useHighlight)([assignmentRange.id].concat(assignmentRange.assigned?.x || []).concat((0, filterForIDsWithAssignment_1.filterForIDsWithAssignment)(assignmentData, signals.map((_signal) => _signal.id))), { type: highlight_1.HighlightEventSource.RANGE, extra: { id } });
    const { scaleX } = (0, ScaleContext_1.useScaleChecked)();
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const isBlockedByEditing = selectedTool && selectedTool === ToolTypes_1.options.editRange.id;
    function handleOnStopResizing(position) {
        dispatch({
            type: 'RESIZE_RANGE',
            payload: {
                range: {
                    ...range,
                    from: scaleX().invert(position.x2),
                    to: scaleX().invert(position.x1),
                },
            },
        });
    }
    function mouseEnterHandler() {
        assignmentRange.show('x');
        highlightRange.show();
    }
    function mouseLeaveHandler() {
        assignmentRange.hide();
        highlightRange.hide();
    }
    function unAssignHandler(signalIndex = -1) {
        dispatch({
            type: 'UNLINK_RANGE',
            payload: {
                range,
                assignmentData,
                signalIndex,
            },
        });
    }
    function assignHandler() {
        if (!isBlockedByEditing) {
            assignmentRange.setActive('x');
        }
    }
    const from = scaleX()(range.from);
    const to = scaleX()(range.to);
    const isNotSignal = !(0, RangeUtilities_1.checkRangeKind)(range);
    const isHighlighted = isBlockedByEditing || highlightRange.isActive || assignmentRange.isActive;
    const isAssigned = (0, isRangeAssigned_1.isRangeAssigned)(range);
    const isResizeingActive = (0, useResizerStatus_1.useResizerStatus)('rangePicking');
    return ((0, jsx_runtime_1.jsxs)("g", { "data-testid": "range", style: { outline: 'none' }, onMouseEnter: mouseEnterHandler, onMouseLeave: mouseLeaveHandler, ...(!assignmentRange.isActive && { css: style }), children: [(0, jsx_runtime_1.jsx)(Resizer_1.default, { tag: "svg", initialPosition: { x1: to, x2: from }, onEnd: handleOnStopResizing, parentElement: viewerRef, disabled: !isResizeingActive, children: ({ x1, x2 }, isActive) => {
                    const width = x2 - x1;
                    return ((0, jsx_runtime_1.jsxs)("g", { children: [isAssigned && !isHighlighted && !isActive && ((0, jsx_runtime_1.jsx)("rect", { width: width, height: "10px", fill: "#ffd700", opacity: "0.35", "data-no-export": "true" })), (0, jsx_runtime_1.jsx)("rect", { width: width, height: "100%", fill: isHighlighted || isActive ? '#ff6f0057' : 'transparent', "data-no-export": "true" }), (0, jsx_runtime_1.jsx)(IntegralIndicator_1.IntegralIndicator, { value: integration, format: relativeFormat, width: width, opacity: isNotSignal ? 0.5 : 1 })] }));
                } }, `${id}_${to}_${from}`), showMultiplicityTrees && ((0, jsx_runtime_1.jsx)(MultiplicityTree_1.MultiplicityTree, { range: range, onUnlink: unAssignHandler })), (0, jsx_runtime_1.jsx)(AssignmentActionsButtons_1.AssignmentActionsButtons, { isActive: !!(assignmentRange.isActive || diaIDs), x: from - 16, onAssign: assignHandler, onUnAssign: () => unAssignHandler() })] }, id));
}
exports.default = Range;
